import {Tr} from "@/i18n/i18n";
import {SkillType} from "@/store/place/types";
import {Keys} from "@/constants/key";
import {Skill} from "@/store/level/types";
import PlayerStore from "@/store/player";

export default class SkillUtils {
    // @ts-ignore
    public static getSkillText(skillType: SkillType): string {
        switch (skillType) {
            case SkillType.ATTACK:
                return Tr('ataka');
            case SkillType.DEFENCE:
                return Tr('zaschita');
            case SkillType.HEALTH:
                return Tr('zdorove');
        }
    }

    public static getSkillIcon(skillType: SkillType): string {
        switch (skillType) {
            case SkillType.ATTACK:
                return Keys.IMG_ATTACK;
            case SkillType.DEFENCE:
                return Keys.IMG_DEFENCE;
            case SkillType.HEALTH:
                return Keys.IMG_HEART_ICON;
            case SkillType.POISON:
                return Keys.IMG_HEART_ICON;
            case SkillType.IMMORTALITY:
                return Keys.IMG_HEART_ICON;
        }
    }

    public static getSkill(skills: Skill[], skillType: SkillType): Skill {
        for (let skill of skills) {
            if (skill.skillType === skillType) {
                return skill;
            }
        }
        throw Error('Unknown skill');
    }

    public static getSkillValue(skills: Skill[], skillType: SkillType): number {
        return this.getSkill(skills, skillType).valueCurrent;
    }

    public static formatValue(value: number | undefined): string {
        if (!value) {
            return '';
        }
        value = Math.round(value);
        if (value > 9999) {
            if (value > 999999999) {
                if (value >= 1e54) {
                    return String((value / 1e54).toFixed((value % 1e54 === 0 || value >= 1e56) ? 0 : 1)) + 'L';
                }
                if (value >= 1e51) {
                    return String((value / 1e51).toFixed((value % 1e51 === 0 || value >= 1e53) ? 0 : 1)) + 'J';
                }
                if (value >= 1e48) {
                    return String((value / 1e48).toFixed((value % 1e48 === 0 || value >= 1e50) ? 0 : 1)) + 'H';
                }
                if (value >= 1e45) {
                    return String((value / 1e45).toFixed((value % 1e45 === 0 || value >= 1e47) ? 0 : 1)) + 'C';
                }
                if (value >= 1e42) {
                    return String((value / 1e42).toFixed((value % 1e42 === 0 || value >= 1e44) ? 0 : 1)) + 'B';
                }
                if (value > 999999999999999999999999999999999999999) {
                    return String((value / 1000000000000000000000000000000000000000).toFixed((value % 1000000000000000000000000000000000000000 == 0 || value >= 100000000000000000000000000000000000000000) ? 0 : 1)) + 'A';
                }
                if (value > 999999999999999999999999999999999999) {
                    return String((value / 1000000000000000000000000000000000000).toFixed((value % 1000000000000000000000000000000000000 == 0 || value >= 100000000000000000000000000000000000000) ? 0 : 1)) + 'D';
                }
                if (value > 999999999999999999999999999999999) {
                    return String((value / 1000000000000000000000000000000000).toFixed((value % 1000000000000000000000000000000000 == 0 || value >= 100000000000000000000000000000000000) ? 0 : 1)) + 'F';
                }
                if (value > 999999999999999999999999999999) {
                    return String((value / 1000000000000000000000000000000).toFixed((value % 1000000000000000000000000000000 == 0 || value >= 100000000000000000000000000000000) ? 0 : 1)) + 'Q';
                }
                if (value > 999999999999999999999999999) {
                    return String((value / 1000000000000000000000000000).toFixed((value % 1000000000000000000000000000 == 0 || value >= 100000000000000000000000000000) ? 0 : 1)) + 'R';
                }
                if (value > 999999999999999999999999) {
                    return String((value / 1000000000000000000000000).toFixed((value % 1000000000000000000000000 == 0 || value >= 100000000000000000000000000) ? 0 : 1)) + 'Y';
                }
                if (value > 999999999999999999999) {
                    return String((value / 1000000000000000000000).toFixed((value % 1000000000000000000000 == 0 || value >= 100000000000000000000000) ? 0 : 1)) + 'S';
                }
                if (value > 999999999999999999) {
                    return String((value / 1000000000000000000).toFixed((value % 1000000000000000000 == 0 || value >= 100000000000000000000) ? 0 : 1)) + 'E';
                }
                if (value > 999999999999999) {
                    return String((value / 1000000000000000).toFixed((value % 1000000000000000 == 0 || value >= 100000000000000000) ? 0 : 1)) + 'P';
                }
                if (value > 999999999999) {
                    return String((value / 1000000000000).toFixed((value % 1000000000000 == 0 || value >= 100000000000000) ? 0 : 1)) + 'T';
                }
            }
            if (value > 999999999) {
                return String ((value / 1000000000).toFixed((value % 1000000000 == 0 || value >= 100000000000) ? 0 : 1)) + 'G';
            }
            if (value > 999999) {
                return String ((value / 1000000).toFixed((value % 1000000 == 0 || value >= 100000000) ? 0 : 1)) + 'M';
            }
            if (value > 99999) {
                return String ((value / 1000).toFixed(0)) + 'k';
            }
            return String ((value / 1000).toFixed((value % 1000 == 0) ? 0 : 1)) + 'k';
        }
        return String(value);
    }

    public static formatMoreThanMillion(value: number): string {
        if (value > 999999) {
            return this.formatValue(value);
        }
        return String(value);
    }

    public static formatHealth(value: number): string {
        if (value < 0) {
            return '-' + this.formatHealth(-value);
        }
        if (value <= 9999) {
            return String(value);
        }
        if (value < 1e6) {
            return this.scaledFormat(value, 1e3) + 'k';
        }
        if (value < 1e9) {
            return this.scaledFormat(value, 1e6) + 'M';
        }
        if (value < 1e12) {
            return this.scaledFormat(value, 1e9) + 'G';
        }
        if (value < 1e15) {
            return this.scaledFormat(value, 1e12) + 'T';
        }
        if (value < 1e18) {
            return this.scaledFormat(value, 1e15) + 'P';
        }
        if (value < 1e21) {
            return this.scaledFormat(value, 1e18) + 'E';
        }
        if (value < 1e24) {
            return this.scaledFormat(value, 1e21) + 'S';
        }
        if (value < 1e27) {
            return this.scaledFormat(value, 1e24) + 'Y';
        }
        if (value < 1e30) {
            return this.scaledFormat(value, 1e27) + 'R';
        }
        if (value < 1e33) {
            return this.scaledFormat(value, 1e30) + 'Q';
        }
        if (value < 1e36) {
            return this.scaledFormat(value, 1e33) + 'F';
        }
        if (value < 1e39) {
            return this.scaledFormat(value, 1e36) + 'D';
        }
        if (value < 1e42) {
            return this.scaledFormat(value, 1e39) + 'A';
        }
        if (value < 1e45) {
            return this.scaledFormat(value, 1e42) + 'B';
        }
        if (value < 1e48) {
            return this.scaledFormat(value, 1e45) + 'C';
        }
        if (value < 1e51) {
            return this.scaledFormat(value, 1e48) + 'H';
        }
        if (value < 1e54) {
            return this.scaledFormat(value, 1e51) + 'J';
        }
        return this.scaledFormat(value, 1e54) + 'L';
    }

    private static scaledFormat(value: number, scale: number): string {
        const m = value / (scale / 10.0);
        const ret = Math.round(m);
        const s = String(ret);
        if (s.length < 2) {
            return '0.' + s;
        }
        let res = s.substring(0, s.length - 1) + '.' + s.substring(s.length - 1);
        if (res.length > 2 && res.endsWith('.0')) {
            res = res.substring(0, res.length - 2);
        }
        return res;
    }

    public static getPileImage(skillType: SkillType) {
        switch (skillType) {
            case SkillType.ATTACK:
                return Keys.SK_ATTACK;
            case SkillType.DEFENCE:
                return Keys.SK_DEFENCE;
            case SkillType.HEALTH:
                return Keys.SK_HEALTH;
        }
        return Keys.SK_HEALTH;
    }
}
